import React, { useEffect, useState, useRef } from 'react';
import DatePicker from 'react-datepicker/es';
import axios from 'axios';
// import {parseISO} from "date";

const ProfitCalculator = ({ symbol }) => {

  const language = drupalSettings.path.currentLanguage || '';
  const endpoint = '/' + language + '/api/market/' + symbol + '/day';
  const [shares, setShares] = useState('1');
  const [pricepershare, setPricePerShare] = useState('');
  const [customPriecePerShare, setCustomPriecePerShare] = useState(undefined);
  const [errorMsg, setErrorMsg] = useState('');
  const [selectedDate, setSelectedDate] = useState(lastBusinessDay()); // date picker
  const [lastDayData, setLastDayData] = useState(undefined); // from api
  const [selectedDayData, setSelectedDayData] = useState(undefined); // from api

  var mul = 1;
  if (!customPriecePerShare && symbol == 'EAT.WAR' && selectedDayData) {
    if (selectedDayData.date) {
      var d1 = ('03-10-2018').split('-');
      var d2 = selectedDayData.date.split('-');
      var c1 = Date.parse(d1[2] + '-' + d1[1] + '-' + d1[0]);
      var c2 = Date.parse(d2[0] + '-' + d2[1] + '-' + d2[2]);
      if (c1 > c2) {
        mul = 10;
      }
    }
  }

  useEffect(() => {
    if (lastDayData === undefined) {
      getData(endpoint);
    }
  });

  // get data from endpoint
  // if date is not set, then last is used
  function getData(endpoint, date) {
    let query;
    if (date) {
      query = endpoint + `?date=${date}`;
    } else {
      query = endpoint + '/last';
    }
    axios
      .get(query)
      .catch(error => {
        setErrorMsg(Drupal.t('No data'));
      })
      .then(resp => {
        if (resp && resp.status === 200) {
          if (date) {
            if (customPriecePerShare) {
              ;
            } else {
              setSelectedDayData(resp.data);
              setPricePerShare(resp.data.price_close);
            }
          } else {

            setLastDayData(resp.data);
            if (customPriecePerShare) {
              ;
            } else {
              setSelectedDate(new Date(resp.data.date));
            }
          }
        } else {
          setErrorMsg(Drupal.t('No data'));
        }
      });
  }

  function calculateProfit(mul) {
    let diff;
    if (selectedDayData && lastDayData) {
      diff = shares * (lastDayData.price_close - selectedDayData.price_close);
      return (Math.round(diff * 100 * Number(mul))) / 100;
    } else {
      return '';
    }
  }

  function isWeekday(date) {
    const day = (new Date(date)).getDay();
    return day !== 0 && day !== 6;
  };

  return (
    <>
      <form className="calculators">
        <div className="shares form-group form--input-wrapper">
          <label
            className="">{Drupal.t('Number of shares', {}, { context: 'Stock' })}:</label>
          <input className="form-control" type="text" value={shares}
                 onChange={event => {
                   setShares(event.target.value);
                 }}/>
        </div>
        <div className="date form-group form--select-wrapper form-date-select">
          <label>{Drupal.t('Date of shares purchase', {}, { context: 'Stock' })}:</label>
          <DatePicker
            selected={selectedDate}
            maxDate={lastDayData ? new Date(lastDayData.date) : lastBusinessDay()}
            minDate={new Date('2005-01-01')}
            onChange={dateFromPicker => {
              setCustomPriecePerShare(false);
              setSelectedDate(dateFromPicker);
            }}
            className="form-control"
            dateFormat="dd-MM-yyyy"
            filterDate={isWeekday}
          />
          <i className="fa fa-calendar"></i>
          <div className="">
            <span
              className="mt-2 errorMsg badge badge-warning">{errorMsg}</span>
          </div>
        </div>
        <div className="price form-group form--input-wrapper input-inactive">
          <label className="">:</label>
          <input className="form-control" type="text"
                 placeholder={Drupal.t('Purchase price per share', {}, { context: 'Stock' })}
                 value={pricepershare} disabled onChange={
            event => {
              setPricePerShare(event.target.value);
              setCustomPriecePerShare(true);
              setSelectedDayData({ price_close: event.target.value });
            }
          }/>
        </div>
        <div className="calculate form-group">
          <input type="button" value={Drupal.t('Calculate')}
                 className="w-100 btn btn-calculator"
                 onClick={() => {
                   setErrorMsg('');
                   getData(endpoint, formatDate(selectedDate));
                 }}/>
        </div>
        <div className="small-container">
          <div className="value form-group form--input-wrapper input-inactive">
            <label>{Drupal.t('Value of shares package', {}, { context: 'Stock' })}: </label>
            <input type="text" className="form-control" disabled
                   value={parseFloat(lastDayData ? Number(shares) * lastDayData.price_close * Number(mul) : 0).toFixed(2)}/>
          </div>
          <small
            className="form-text text-muted">{Drupal.t('From date')}: <span>{lastDayData ? lastDayData.date : ''}</span></small>
        </div>
        <div className="profit form-group form--input-wrapper input-inactive">
          <label
            className="">{Drupal.t('Profit (gross)', {}, { context: 'Stock' })}: </label>

          <input type="text" className="form-control" disabled
                 value={calculateProfit(mul)}/>
        </div>
        <div className="calculator-disclimer">
          {symbol == 'EAT.WAR' ? Drupal.t('The calculation is made based on the closing price on the selected date of shares purchase.', {}, { context: 'Stock' }) : ''}
          {symbol == 'EAT.MC' ? Drupal.t('The calculation is made based on the closing price on the selected date of shares purchase.', {}, { context: 'Stock' }) : ''}
          <br/><br/>{symbol == 'EAT.WAR' ? Drupal.t('For shares purchased prior to October 03, 2018, the calculation takes into account an effect of the stock split executed on that date.', {}, { context: 'Stock' }) : ''}
        </div>
      </form>
    </>
  );
};

// return date in YYYY-MM-DD format
function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) {
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }

  return [year, month, day].join('-');
}

// since yesterday
function lastBusinessDay() {
  let daysBefore = 1;
  let today = (new Date()).getDay();
  switch (today) {
    case 1:
      daysBefore = 3; // monday -> friday
      break;
    case 0:
      daysBefore = 2; // sunday -> friday
      break;
  }
  return new Date(Date.now() - daysBefore * 86400000);
}

export default ProfitCalculator;
